import React from "react";
import Header from "./Header";
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        position: 'relative'
    }
})

const Layout = ({children}) => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <Header/>
            <div style={{overflow: 'auto', height: 'calc(100% - 41px)', position: 'relative'}}>
                {children}
            </div>
        </div>
    )
}
export default Layout